import BreadCrumb from "Common/BreadCrumb";
import { BasicButton, SelectComponent, SelectSessionValidation } from "Common/Components";
import TableContainer from "Common/TableContainer";
import { LucideDot } from "lucide-react";
import { useTranslation } from "react-i18next";
import DeleteModal from "Common/DeleteModal";
import { useCorrelativeList } from "../../hooks/useCorrelativeList";
import { ModalFormCreateCorrelative } from "../../components/modalFormCreate";

export const CorrelativoListView = () => {
  const { t } = useTranslation();

  const {
    columns,
    correlativeRows,
    showDeleteModal,
    showCreateModal,
    onHideModal,
    onhandleCreateEmploye,
    onDeleteConfirm,
    onHideCreateEdithModal,

  } = useCorrelativeList();

  return (
    <>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <DeleteModal
          show={showDeleteModal}
          onHide={onHideModal}
          onDelete={onDeleteConfirm}
        />
        <BreadCrumb
          title={t("correlativeScreen.titleListPage")}
          pageTitle={t("menu.correlative")}
        />
        <div className="card">
          <div className="card-body">
            <div className="flex w-full items-center justify-between flex-wrap">
              <div className="flex flex-1 justify-end mt-4">
                <BasicButton onClick={onhandleCreateEmploye} type="button">
                  <div className="flex flex-row justify-center items-center">
                    <LucideDot size={16} color="#fff" />
                    <span className="ml-2 text-slate-50">
                      {t("correlativeScreen.BtnAddCorrelative")}
                    </span>
                  </div>
                </BasicButton>
              </div>
                <div className="w-full pt-6">
              <TableContainer
                isPagination={true}
                columns={columns}
                data={correlativeRows}
                isTfoot={false}
                isSelect={true}
                isGlobalFilter={true}
                divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
                tableclassName="display stripe group dataTable w-full text-sm align-middle whitespace-nowrap"
                theadclassName="border-b border-slate-200 dark:border-zink-500"
                thclassName="ltr:!text-left rtl:!text-right p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500 sorting_asc"
                tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              ></TableContainer>
            </div>
            <ModalFormCreateCorrelative
              showModal={showCreateModal}
              onHide={onHideCreateEdithModal}
            />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
